import React, { useState, useEffect } from "react";
import s from "./SteppersOrders.module.css";

//Servicios
import providersService from "../../../../../api/providers/providersService";
import gamesService from "../../../../../api/games/GamesService";

//Assets
import ProvidersModal from "../../../../Shared/ProvidersModal";
import ProductosModal from "../../../../Shared/ProductosModal";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
//Material
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import FormControl from "@mui/material/FormControl"
import Grid from "@mui/material/Grid"
import InputAdornment from "@mui/material/InputAdornment"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"
import ToggleButton from "@mui/material/ToggleButton"
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import ordersDetailService from "../../../../../api/delivery/ordersDetailService/ordersDetailService";
import ordersService from "../../../../../api/delivery/ordersServices";
import useTranslationException from "../../../../../helpers/exceptions";
import { useNotificationContext } from "../../../../Notifications/CustomNotifications";

// ============================ | STEPPER ONE | ===============================

const StepperOne = ({ form, setForm, providerSelect, setProviderSelect }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setForm((prev) => ({ ...prev, supplierId: providerSelect.id }));
  }, [providerSelect]);

  return (
    <Grid container className={s.container} mb={10}>
      <Box className={s.title}>
        <h4>{t("orderHead")}</h4>
      </Box>
      <Grid
        item
        container
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "space-between",
        }}
      >
        <Grid item lg={7} xs={11} className={s.toggleButton}>
          <h3>{t("state")}</h3>
          <ToggleButtonGroup
            size="small"
            color="primary"
            value={form.status}
            exclusive
            onChange={(e) =>
              setForm((prev) => ({ ...prev, status: e.target.value }))
            }
          >
            <ToggleButton value="En Proceso">{t("inProcess")}</ToggleButton>
            <ToggleButton value="Activo">{t("active")}</ToggleButton>
            <ToggleButton value="Enviado">{t("sent")}</ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid item lg={7} xs={11} className={s.input} mb={2}>
          <TextField
            id="input-with-icon-textfield"
            value={providerSelect?.businessName}
            sx={{ cursor: "pointer", width: "100%" }}
            onClick={() => setOpen(true)}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ cursor: "pointer" }} />
                </InputAdornment>
              ),
            }}
          ></TextField>
        </Grid>
        <ProvidersModal
          open={open}
          setOpen={setOpen}
          selectProvider={setProviderSelect}
        />
        <Grid item lg={7} xs={11} className={s.input}>
          <TextField
            label={t("observations")}
            sx={{ width: "100%" }}
            value={form.observations}
            multiline
            rows={6}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, observations: e.target.value }))
            }
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

// ============================ | STEPPER TWO | ===============================

const StepperTwo = ({ setForm, form, raffles, setRaffles, edit }) => {
  const notification = useNotificationContext();
  const showExpetion = useTranslationException();
  const { t } = useTranslation();
  const { allGameOffersActive } = useSelector((state) => state.gamma);
  const { textColor } = useSelector((state) => state.local);
  const organization = useSelector((state) => state.gamma.activeOrganization);

  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingDetailDelete, setLoadingDetailDelete] = useState(0);
  const [providerGames, setProviderGames] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [selectedGame, setSelectedGame] = useState({});
  const [raffleSelected, setRaffleSelected] = useState({
    number: t("selectProduct"),
  });
  const [openModal, setOpenModal] = useState(false);

  const [itemForm, setItemForm] = useState({
    gameId: 0,
    amount: 0,
    raffleId: 0,
  });

  const dispatch = useDispatch();

  const handleAdd = () => {
    let exist = form.detailOrdersList.find(function (obj) {
      return obj.raffleId === itemForm.raffleId;
    });

    if (exist) {
      Swal.fire(t("existProduct"), t("notDoubleProduct"), "error");
      setSelectedGame({});
      setRaffleSelected({ number: t("selectProduct") });
      setItemForm({
        gameId: 0,
        amount: 0,
        raffleId: 0,
      });
    } else {
      setLoadingDetail(true);
      if (edit.status) {
        ordersDetailService
          .createDetail(form?.id, itemForm)
          .then(() => {
            ordersService.getOrderById(form?.id).then((response) => {
              let newDetails = response.detailOrdersList.map((item) => ({
                id: item.id,
                gameId: item.game.id,
                amount: item.amount,
                nroCouponFrom: item.nroCouponFrom,
                nroCouponTo: item.nroCouponTo,
                raffleId: item.raffle.id,
              }));
              setRaffles(response?.detailOrdersList);
              setForm((prev) => ({ ...prev, detailOrdersList: newDetails }));
            });
          })
          .then(() => {
            setSelectedGame({});
            setRaffleSelected({ number: t("selectProduct") });
            setItemForm({
              gameId: 0,
              amount: 0,
              raffleId: 0,
            });
            setLoadingDetail(false);
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("anErrorOccurred,TryAgain"),
              t("sorryErrorOcurred"),
            );
            setLoadingDetail(false);
          });
      } else {
        setForm((prev) => ({
          ...prev,
          detailOrdersList: [...prev.detailOrdersList, itemForm],
        }));
        setRaffles([...raffles, { raffle: raffleSelected }]);
        setSelectedGame({});
        setRaffleSelected({ number: t("selectProduct") });
        setItemForm({
          gameId: 0,
          amount: 0,
          raffleId: 0,
        });
        setLoadingDetail(false);
      }
    }
  };

  const handleDelete = (item) => {
    setLoadingDetailDelete(item?.id);
    if (edit.status) {
      ordersDetailService
        .deleteDetail(form?.id, item?.id)
        .then(() => {
          ordersService.getOrderById(form?.id).then((res) => {
            let detail = res.detailOrdersList.map((item) => ({
              ...item,
              id: item.id,
              gameId: item.game.id,
              raffleId: item.raffle.id,
              amount: item.amount,
            }));
            setForm({
              ...form,
              detailOrdersList: detail,
            });
          });
        })
        .then(() => {
          let filterRaffles = raffles.filter(
            (r) => r?.raffleReadDTO?.id !== item.raffleId,
          );
          setRaffles(filterRaffles);
        })
        .then(() => setLoadingDetailDelete(0))
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoadingDetailDelete(0);
        });
    } else {
      setForm((prev) => ({
        ...prev,
        detailOrdersList: prev.detailOrdersList.filter(
          (detail) => detail.raffleId !== item.raffleId,
        ),
      }));
      setRaffles((prev) => prev.filter((r) => r.raffle.id !== item.raffleId));
      setLoadingDetailDelete(0);
    }
  };

  useEffect(() => {
    itemForm.nroCouponFrom && itemForm.nroCouponTo
      ? setItemForm({
        ...itemForm,
        amount: itemForm.nroCouponTo - itemForm.nroCouponFrom + 1,
      })
      : setItemForm({ ...itemForm, amount: 0 });
  }, [itemForm.nroCouponFrom, itemForm.nroCouponTo]);

  useEffect(() => {
    setLoading(true);
    providersService
      .getGamesProvider(form.supplierId, dispatch)
      .then((res) => setProviderGames(res.gamesIds))
      .then(() => setLoading(false))
      .catch((error) => {
        notification.error("Error endpoint", error.message);
      });
  }, [form.supplierId]);

  useEffect(() => {
    setLoading(true);
    gamesService
      .getAllActivesGameOffers(dispatch)
      .then(() => setLoading(false));
  }, [organization?.id, dispatch]);

  useEffect(() => {
    if (itemForm.gameId) {
      let data = allGameOffersActive?.find(
        (i) => i.modality?.game?.id === itemForm.gameId,
      );
      if (data) {
        setSelectedGame(data.modality);
      } else {
        setSelectedGame({});
      }
    } else {
      setSelectedGame({});
    }
  }, [itemForm.gameId]);

  // Section: JSX
  return (
    <Grid container className={s.container}>
      <Box className={s.title} id="table-details">
        <h4>{t("details")}</h4>
      </Box>
      {!providerGames?.filter((g) =>
        allGameOffersActive?.find((i) => i.modality?.game?.id === g),
      ).length ? (
        <Grid item xs={12} className={s.noActiveGames}>
          {loading ? <CircularProgress /> : t("providerNoActiveGames")}
        </Grid>
      ) : (
        <>
          <Grid container item xs={12} className={s.twoData}>
            {form?.detailOrdersList?.length ? (
              <TableContainer className={s.tableContainer}>
                <Table>
                  <TableHead sx={{ backgroundColor: "primary.main" }}>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("game")}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("quantity")}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("drawNumber")}/{t("serie")}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: textColor,
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("delete")}
                    </TableCell>
                  </TableHead>
                  <TableBody>
                    {form?.detailOrdersList?.map((item, i) => (
                      <React.Fragment key={i}>
                        <TableRow>
                          <TableCell sx={{ fontSize: "0.9rem" }}>
                            {item.game
                              ? item.game.name
                              : allGameOffersActive?.find(
                                (i) => i.modality?.game?.id === item.gameId,
                              )?.modality?.game?.name || "-"}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.9rem" }}>
                            {item.amount}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.9rem" }}>
                            {raffles[i]?.raffle?.number ||
                              raffles[i]?.raffle?.serie ||
                              "-"}
                          </TableCell>
                          <TableCell align="center">
                            {loadingDetailDelete === item.id ? (
                              <CircularProgress color="primary" size="1.8rem" />
                            ) : (
                              <DeleteForeverRoundedIcon
                                sx={{
                                  color: "primary.main",
                                  fontSize: "1.8rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleDelete(item)}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              t("noDetails")
            )}
          </Grid>
          <Grid
            item
            xs={12}
            className={s.newElemButton}
            sx={{ display: openForm ? "none" : "flex" }}
          >
            <Button
              sx={{ color: textColor }}
              variant="contained"
              disabled={loading}
              onClick={() => setOpenForm(true)}
              href="#add-form"
            >
              {loading ? <CircularProgress /> : t("add")}
            </Button>
          </Grid>
          {openForm ? (
            <Grid
              item
              container
              xs={12}
              className={s.stepTwoForm}
              id="add-form"
            >
              <h3>{`${t("add")} ${t("details")}`}</h3>
              <Grid item container xs={12} spacing={1} className={s.addForm}>
                <Grid item xs={12} lg={5} className={s.input}>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel id="select-label-provider">
                      {t("game")}
                    </InputLabel>
                    <Select
                      labelId="select-label-provider"
                      value={itemForm.gameId}
                      label={t("game")}
                      onChange={(e) =>
                        setItemForm({ ...itemForm, gameId: e.target.value })
                      }
                    >
                      <MenuItem value={0}>{t("select")}</MenuItem>
                      {providerGames?.map((g, index) =>
                        allGameOffersActive?.find(
                          (i) => i.modality?.game?.id === g,
                        ) ? (
                          <MenuItem key={index} value={g}>
                            {
                              allGameOffersActive?.find(
                                (i) => i.modality?.game?.id === g,
                              )?.modality?.game?.name
                            }
                          </MenuItem>
                        ) : null,
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                {itemForm.gameId === 0 ? null : loading ? (
                  <Grid item xs={12} className={s.input}>
                    <CircularProgress />
                  </Grid>
                ) : (
                  <>
                    <Grid item xs={5} className={s.input}></Grid>
                    <Grid
                      item
                      xs={12}
                      lg={5}
                      className={s.input}
                      sx={{ justifyContent: "space-between" }}
                    >
                      <TextField
                        label={t("quantity")}
                        sx={{ width: "100%" }}
                        type={"number"}
                        onChange={(e) => {
                          if (
                            !isNaN(e.target.value) &&
                            Number(e.target.value) >= 0
                          ) {
                            setItemForm((prev) => ({
                              ...prev,
                              amount: Number(e.target.value) || null,
                            }));
                          }
                        }}
                        onKeyPress={(e) => {
                          if (e?.key === "-" || e?.key === "+") {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(event) => {
                          event.preventDefault();
                        }}
                      />
                    </Grid>
                    <Grid item xs={5} className={s.input}></Grid>
                    <Grid
                      item
                      xs={12}
                      lg={5}
                      className={s.input}
                      sx={{ justifyContent: "space-between" }}
                      onClick={() => setOpenModal(true)}
                    >
                      <TextField
                        value={(() => {
                          if (
                            raffleSelected?.serie != null &&
                            raffleSelected?.serie != ""
                          ) {
                            return t("serie") + ": " + raffleSelected.serie;
                          } else if (raffleSelected?.number) {
                            return t("raffle") + ": " + raffleSelected.number;
                          } else {
                            return t("select");
                          }
                        })()}
                        disabled={true}
                        sx={{ cursor: "pointer", width: "100%" }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon sx={{ cursor: "pointer" }} />
                            </InputAdornment>
                          ),
                        }}
                      ></TextField>
                    </Grid>
                    {openModal ? (
                      <ProductosModal
                        open={openModal}
                        setOpen={setOpenModal}
                        data={{
                          number: form?.supplierId,
                          type: "proveedor",
                        }}
                        game={selectedGame}
                        selectProduct={setRaffleSelected}
                        setDetail={setItemForm}
                      />
                    ) : null}
                  </>
                )}
              </Grid>
              <Grid item lg={12} xs={11}>
                <Button
                  variant="contained"
                  sx={{ color: textColor, marginRight: 1 }}
                  onClick={handleAdd}
                  disabled={
                    itemForm.gameId === 0 ||
                    itemForm.raffleId === 0 ||
                    itemForm.amount <= 0 ||
                    loadingDetail
                  }
                >
                  {loadingDetail ? <CircularProgress size="2rem" /> : t("add")}
                </Button>
                <Button
                  variant="contained"
                  sx={{ color: textColor }}
                  onClick={() => {
                    setSelectedGame({});
                    setRaffleSelected({ number: t("selectProduct") });
                    setItemForm({
                      gameId: 0,
                      amount: 0,
                      nroCouponFrom: 0,
                      nroCouponTo: 0,
                      raffleId: 0,
                    });
                    setOpenForm(false);
                  }}
                >
                  {t("cancel")}
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </>
      )}
    </Grid>
  );
};

// ============================ | CONFIRM STEPPER | ===============================

const ConfirmStepper = ({ form, raffles }) => {
  const { t } = useTranslation();
  const { textColor } = useSelector((state) => state.local);
  const providersRedux = useSelector((state) => state.gamma.providers);
  const gamesRedux = useSelector((state) => state.gamma.allGameOffersActive);

  return (
    <Grid container className={s.confirm}>
      <Grid item xs={10} className={s.titleContainer}>
        <h4>{t("details")}</h4>
      </Grid>
      <Grid container item xs={12} className={s.info}>
        <Accordion
          sx={{ width: "100%" }}
          defaultExpanded={true}
          className={s.accordion}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: textColor }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{
              backgroundColor: "primary.main",
              color: textColor,
              borderRadius: "5px 5px 0 0",
            }}
          >
            <Box className={s.summary}>
              <Typography
                className={s.titleData}
              >{`${t("purchaseOrder")}`}</Typography>
              <Typography
                className={s.titleData}
              >{`${t("provider")}: ${providersRedux.filter((p) => p.id === form.supplierId)[0]?.businessName}`}</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <Typography
                className={s.information}
              >{`${t("information")}: ${form.observations}`}</Typography>
              <TableContainer className={s.tableContainer}>
                <Table>
                  <TableHead sx={{ backgroundColor: "primary.main" }}>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("game")}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("drawNumber")}/{t("serie")}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("quantity")}
                    </TableCell>
                  </TableHead>
                  <TableBody>
                    {form?.detailOrdersList?.map((item, i) => (
                      <React.Fragment key={item.id}>
                        <TableRow
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {item.game
                              ? item.game.name
                              : gamesRedux?.find(
                                (i) => i.modality?.game?.id === item.gameId,
                              )?.modality?.game?.name || "-"}
                          </TableCell>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {raffles[i]?.raffle?.number ||
                              raffles[i]?.raffle?.serie ||
                              "-"}
                          </TableCell>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {item.amount}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

export {
  StepperOne,
  StepperTwo,
  ConfirmStepper
};
